import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchFDIncentives,
  fetchIncentivesSlabs,
  fetchIncentivesStats,
  fetchTrainerIncentives,
  fetchTrainerNotificationLogs,
} from "./incentivesApis";

export const fetchIncentivesStatsData = createAsyncThunk(
  "api/fetchIncentivesStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchIncentivesStats(filters, token);
    return response;
  }
);

export const fetchIncentivesSlabsData = createAsyncThunk(
  "api/fetchIncentivesSlabsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchIncentivesSlabs(filters, token);
    return response;
  }
);

export const fetchTrainerIncentivesData = createAsyncThunk(
  "api/fetchTrainerIncentivesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerIncentives(filters, token);
    return response;
  }
);

export const fetchTrainerNotificationLogsData = createAsyncThunk(
  "api/fetchTrainerNotificationLogsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerNotificationLogs(filters, token);
    return response;
  }
);

export const fetchFDIncentivesData = createAsyncThunk(
  "api/fetchFDIncentivesData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchFDIncentives(filters, token);
    return response;
  }
);

const incentivesSlice = createSlice({
  name: "incentives",
  initialState: {
    ptIntentivesStats: null,
    statsLoading: false,
    ptIntentivesStatsError: null,

    ptIncentivesSlabs: null,
    slabLoading: false,

    ptTrainerIncentives: null,
    ptTrainerIncentivesLoading: false,
    ptTrainerIncentivesError: null,

    trainerNotificationLogs: null,
    trainerNotificationLogsLoading: false,
    trainerNotificationLogsError: null,

    error: "",
    loading: false,

    fdIncentives: null,
    fdIncentivesError: null,
    fdIncentivesLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIncentivesStatsData.pending, (state) => {
        state.statsLoading = true;
      })
      .addCase(fetchIncentivesStatsData.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.ptIntentivesStats = action.payload;
      })
      .addCase(fetchIncentivesStatsData.rejected, (state, action) => {
        state.statsLoading = false;
        state.ptIntentivesStatsError = action.error.message;
      })

      .addCase(fetchIncentivesSlabsData.pending, (state) => {
        state.slabLoading = true;
      })
      .addCase(fetchIncentivesSlabsData.fulfilled, (state, action) => {
        state.slabLoading = false;
        state.ptIncentivesSlabs = action.payload;
      })
      .addCase(fetchIncentivesSlabsData.rejected, (state, action) => {
        state.slabLoading = false;
        state.error = action.error.message;
      })

      .addCase(fetchTrainerIncentivesData.pending, (state) => {
        state.ptTrainerIncentivesLoading = true;
      })
      .addCase(fetchTrainerIncentivesData.fulfilled, (state, action) => {
        state.ptTrainerIncentivesLoading = false;
        state.ptTrainerIncentives = action.payload;
      })
      .addCase(fetchTrainerIncentivesData.rejected, (state, action) => {
        state.ptTrainerIncentivesLoading = false;
        state.ptTrainerIncentivesError = action.error.message;
      })

      .addCase(fetchTrainerNotificationLogsData.pending, (state) => {
        state.trainerNotificationLogsLoading = true;
      })
      .addCase(fetchTrainerNotificationLogsData.fulfilled, (state, action) => {
        state.trainerNotificationLogsLoading = false;
        state.trainerNotificationLogs = action.payload;
      })
      .addCase(fetchTrainerNotificationLogsData.rejected, (state, action) => {
        state.trainerNotificationLogsLoading = false;
        state.trainerNotificationLogsError = action.error.message;
      })

      .addCase(fetchFDIncentivesData.pending, (state) => {
        state.fdIncentivesLoading = true;
        state.fdIncentivesError = null;
      })
      .addCase(fetchFDIncentivesData.fulfilled, (state, action) => {
        state.fdIncentivesLoading = false;
        state.fdIncentives = action.payload;
      })
      .addCase(fetchFDIncentivesData.rejected, (state, action) => {
        state.fdIncentivesLoading = false;
        state.fdIncentivesError = action.error.message;
      });
  },
});

export default incentivesSlice.reducer;
